import React, {useEffect} from 'react'
import {useForm} from "react-hook-form";
import Card from "../../components/forms/Card";
import FormGroup, {FormBlockTitle} from "../../components/forms/FormGroup";
import Input from "../../components/forms/FormEl";
import RoleFormSelect from "../../components/selects/RoleFormSelect";
import {Col, Row} from "../../components/flex/FlexLayout";
import Button from "../../components/forms/Button";
import GenderSelect from "../../components/selects/GenderSelect";
const UserForm = ({value, onSubmit}) => {

  const {register, handleSubmit, formState: {errors}, reset} = useForm(
    {defaultValues: value}
  );

  useEffect(() => {
    if (value) {
      reset(value)
    }
  }, [value])

  return (
    <form>
      <Card padding>
        <FormBlockTitle>Credenciales</FormBlockTitle>
        <FormGroup>
          <label>Email</label>
          <Input type='text' {...register("email",{required: 'Campo obligatorio',
            pattern: {
              value: /^[^@]+@[^@]+\.[a-zA-Z]{2,}$/g,
              message: "Correo invalido"
            }})}/>
          {errors.email && <p style={{color: 'red'}}>{errors.email?.message}</p>}
        </FormGroup>

        {value && Object.keys(value).length === 0 && <FormGroup>
          <label>Contraseña</label>
          <Input type='text' {...register("contrasena", {
            required: "Campo obligatorio", minLength: {
              value: 8,
              message: 'Minimo 8 caracteres'
            }
          })}/>
          {errors.contrasena && <p style={{color: 'red'}}>{errors.contrasena?.message}</p>}
        </FormGroup>}

        <FormGroup>
          <label>Rol</label>
          <RoleFormSelect {...register("tipo", {required: "Campo obligatorio"})}/>
          {errors.tipo && <p style={{color: 'red'}}>{errors.tipo?.message}</p>}
        </FormGroup>

      </Card>

      <Card padding>
        <FormBlockTitle>Datos personales</FormBlockTitle>

        <Row>
          <Col>
            <FormGroup>
              <label>Nombres</label>
              <Input type='text' {...register("nombres")}/>
            </FormGroup>
          </Col>
          <Col>
            <FormGroup>
              <label>Apellidos</label>
              <Input type='text' {...register("apellidos")}/>
            </FormGroup>

          </Col>
        </Row>

        <FormGroup>
          <label>Fecha de nacimiento</label>
          <Input type={"date"} {...register("fechaNacimiento", { required: "Campo obligatorio"})}/>
          {errors.fechaNacimiento && <p style={{color: 'red'}}>{errors.fechaNacimiento?.message}</p>}
        </FormGroup>

        <FormGroup>
          <label>Celular</label>
          <Input type='text' {...register("nroCelular")}/>
        </FormGroup>

        <FormGroup>
          <label>Sexo</label>
          <GenderSelect {...register("sexo")} />
        </FormGroup>
      </Card>

      <Button variant={'primary'} onClick={handleSubmit(onSubmit)}>Guardar</Button>
    </form>
  )
}

export default UserForm;
